import React from "react";
import "./animation.css";

function ThreeDots() {
  return <div className='dot-pulse'></div>;
}

export default ThreeDots;
